import React, { useState } from 'react';
import { IconButton, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { doc, deleteDoc } from "firebase/firestore";
import { database } from '../firebaseConfig2';

function EntryPopup(props) {
  const [deleter, deleteClicked] = useState(false);

   //handle row undefined error
    let row = {
        id: "id",
        type: "err",
        message: "error- no item selected"
    }
    if (props.selectedRow != undefined){
        row = props.selectedRow;
    }

    //handle deleting an entry
    const deleteHandler = () => {
        if (props.selectedRow != undefined){
            deleteDoc(doc(database, "statuses", row.id));
            props.openPopup(false);
            deleteClicked(false);
        }
        
    }
    return (
        
        <div className="addmenu-container">
            {/* --------- HEADER -------- */}
            <div className="addmenu-header">
                <h2 id="menutitle">Entry Info</h2>
                <IconButton id="menucloser" onClick={() => props.openPopup(false)}>
                    <CloseIcon />
                </IconButton>
            </div>
            {/* --------- BEGIN FORM -------- */}
            <div className="addmenu-form">
                <h2>entry contents:</h2>
                <div className="isQuote" style={{ display: (row.type == "string") ? 'block' : 'none' }}>
                    <p>{row.message}</p>
                </div>
                <div className="isImage" style={{ display: (row.type == "image") ? 'block' : 'none' }}>
                    <img src={row.message}></img>
                </div>
                <button onClick={()=>deleteClicked(true)}>Delete Entry</button>
                <div className="warning" style={{ display: (deleter == true) ? 'block' : 'none' }}>
                    <p>are you sure you want to delete?</p>
                    <div className='options-container'>
                        <button onClick={()=>deleteHandler()}>Yes</button>
                        <button onClick={()=>deleteClicked(false)}>No</button>
                    </div>
                </div>
            </div>
              
        </div>
       
      );
}

export default EntryPopup;